import React from "react";
function Index({ text }) {
    if (!text || text.length === 0)
        return null;
    return React.createElement("span", { style: { color: 'var(--danger)', fontSize: 12, marginTop: 4 } }, text);
}
export default React.memo(Index);
